import React from "react";
import { Route, Switch } from "react-router-dom";
import AdminInstallation from "../admindashboard/installationGuides/AdminInstallation";
import AdminQuestion from "../admindashboard/Questions/AdminQuestion";
import AddProject from "../task/addproject/AddProject";
import ProjectList from "../task/projectlist/ProjectList";
import TaskList from "../task/tasklist/TaskList";
import UsersList from "../users/UsersList";

function AdminRouteConfig(props) {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={AdminQuestion} />
        <Route exact path="/admin" component={AdminQuestion} />
        <Route exact path="/admin/installation" component={AdminInstallation} />
        <Route exact path="/admin/projects" component={AddProject} />
        <Route exact path="/admin/users" component={UsersList} />
        <Route exact path="/admin/:email/task" component={TaskList} />
      </Switch>
    </div>
  );
}

export default AdminRouteConfig;
